import { GrowthCategory } from '@mc/api'
import { paths } from '@mc/paths'
import { useStaticData } from '@mc/static-data-react'
import { BreadcrumbBar } from 'components/Breadcrumbs'
import { SubcategoryWithOutcome } from 'types/data'
import { useSubcategoryPageEvents } from '../../utils'

export const CategoryBreadcrumbBar = () => {
  const { subcatToOutcomes, primaryCategory } = useStaticData<{
    subcatToOutcomes: SubcategoryWithOutcome
    primaryCategory: GrowthCategory | null
  }>()

  const { trackBreadcrumbClicked } = useSubcategoryPageEvents()

  if (!primaryCategory) return null

  return (
    <BreadcrumbBar className='mc-my-3'>
      <BreadcrumbBar.Item
        href={paths.category(primaryCategory.slug)}
        onClick={() => trackBreadcrumbClicked(primaryCategory.name)}
      >
        {primaryCategory.name}
      </BreadcrumbBar.Item>
      <BreadcrumbBar.Separator />
      <BreadcrumbBar.Item>{subcatToOutcomes.name}</BreadcrumbBar.Item>
    </BreadcrumbBar>
  )
}
